var map = {
	"./angel-face.svg": 3808,
	"./cake.svg": 1399,
	"./heart-face.svg": 2149,
	"./heart.svg": 6229,
	"./laugh-17.svg": 7995,
	"./malicious.svg": 4059,
	"./party-popper.svg": 6360,
	"./smile.svg": 921,
	"./thumb-up.svg": 9705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83;